import React from 'react'
import { Button, Dropdown, Nav, NavLink } from 'react-bootstrap'
import { DisplayTrigger as DisplayTriggerProps } from './DisplayTrigger.d'

const DisplayTrigger: React.FC<DisplayTriggerProps> = ({
    title,
    setIsOpen,
    type = 'button',
    className,
    variant,
    draggable = false,
    extraProps,
    itemRef = null,
}) => {
    return (() => {
        switch (type) {
            case 'button':
                return (
                    <Button
                        ref={itemRef}
                        variant={variant || 'primary'}
                        onClick={() => setIsOpen(true)}
                        className={className}
                        draggable={draggable}
                        {...extraProps}
                    >
                        {title}
                    </Button>
                )
            case 'dropdownItem':
                return (
                    <Dropdown.Item
                        ref={itemRef}
                        className={className}
                        onClick={() => setIsOpen(true)}
                        draggable={draggable}
                        {...extraProps}
                    >
                        {title}
                    </Dropdown.Item>
                )
            case 'navItem':
                return (
                    <Nav.Item
                        ref={itemRef}
                        as="li"
                        draggable={draggable}
                        {...extraProps}
                    >
                        <Button
                            variant="link"
                            style={{ position: 'relative' }}
                            onClick={() => setIsOpen(true)}
                        >
                            {title}
                        </Button>
                    </Nav.Item>
                )
            case 'a':
                return (
                    <NavLink
                        ref={itemRef}
                        onClick={() => setIsOpen(true)}
                        className={className}
                        draggable={draggable}
                        {...extraProps}
                    >
                        {title}
                    </NavLink>
                )
        }
    })()
}

export default DisplayTrigger
